import Component from './DeleteUsersButtonContainer'

export default Component
